/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-03-06 16:29:51
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';

import './index.css'
import BsyButton from '../BsyButton';
import BsySelect from '../BsySelect';
import BsyRadioGroup from '../BsyRadioGroup';
import BsyNumber from '../BsyNumber';
import { BsyUtils } from '../../utils/Utils';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import BsySlidePane from '../BsySlidePane';
import { BsyConfig } from '../../global/BsyConfig';


export default class BsyBatchPrintQrcodePane extends BsyWidget {
    static defaultProps = {
        appId: '',
        entryId: '',
        doPrint: !1,
        limit: 500,
        records: [],
        dataList: [],
        qrType: 'data',
        field: '',
        sort: [],
        fields: [],
        qrStyle: { margin: [0, 0, 0, 0], grid: { row: 4, col: 3 } },
        isLoading: false,
    }
    constructor(props) {
        super(props);
        this.state = {
            ...props,

            qrFields: this._createFieldQrcodeItems(props.fields),
            qrStyle: BsyUtils.Store.get(this._getQrStyleKey(props.appId, props.entryId)) || props.qrStyle,
            field: window.FX.STATIC.PRINTQR ? window.FX.STATIC.PRINTQR.field ? window.FX.STATIC.PRINTQR.field : "" : ""
        }
        this.fieldRef = React.createRef();
    }

    componentDidMount() {
        super.componentDidMount();
        let that = this;
        setTimeout(() => {
            that.renderFields();
        }, 100)
    }

    _createFieldQrcodeItems = (fields) => {
        let i = [];
        BsyUtils.forEach(fields, function (e, t) {
            window.FX.Utils.isFieldValid(t.name) && -1 < BsyConfig().LimitFields.fieldQrcode.indexOf(t.type) && i.push({
                text: t.text,
                value: t.name
            })
        })
        return i
    }

    _getQrStyleKey = (appId, entryId) => {

        return BsyUtils.Store.getKey("qrStyle", {
            appId: appId,
            entryId: entryId
        })
    }

    _getQrDataKey = (appId, entryId) => {

        return BsyUtils.Store.getKey("QrData", {
            appId: appId,
            entryId: entryId
        })
    }

    renderFields = () => {
        const { fields, qrType } = this.state;
        if (qrType === 'data') {

            window.$(this.fieldRef.current).empty();
            this.fieldTitleQrcode = new window.FX.EditFieldTitle({
                renderEl: window.$(this.fieldRef.current),
                width: 400,
                fields: fields,
                allowBlank: !1,
                searchable: !1,
                onEnter: !1,
                mode: 'qrprint',
            });
            this.fieldTitleQrcode.setTemplate(window.FX.STATIC.PRINTQR ? window.FX.STATIC.PRINTQR.data ? window.FX.STATIC.PRINTQR.data : "" : "");
        }

    }

    onPrint = () => {
        const { qrStyle, qrType, idList, sort, filter, isPrintAll, field } = this.state
        var a = {
            margin: [],
            grid: { ...qrStyle.grid }
        };
        BsyUtils.forEach(qrStyle.margin, function (e, t) {
            var i = t; //BsyUtils.parseMm2Pt(t);
            a.margin.push(i)
        });
        var t = {
            qrStyle: a,
            idList: idList,
            filter: filter,
            jsplatform: "React",
            sort: sort,
            isPrintAll: isPrintAll,
            qrType: qrType
        };

        if ("field" === t.qrType) {
            var s = field;
            if (BsyUtils.isObjectEmpty(s)) {
                tipAlert({
                    type: "warning",
                    msg: React.language("print.qrcode.field.empty")
                });
                return
            }
            t.field = s
            window.FX.STATIC.PRINTQR = window.FX.STATIC.PRINTQR || {};
            window.FX.STATIC.PRINTQR[t.qrType] = s;

        }
        else {
            var a1 = this.fieldTitleQrcode.getTemplate();

            var s = {
                mode: "template",
                template: a1
            }
            if (!this.fieldTitleQrcode.checkValidate(s))
                return;
            if (BsyUtils.isObjectEmpty(a1)) {
                tipAlert({
                    type: "warning",
                    msg: React.language("print.qrcode.field.empty")
                });
                return
            }

            t.dataTitle = a1
            window.FX.STATIC.PRINTQR = window.FX.STATIC.PRINTQR || {};
            window.FX.STATIC.PRINTQR[t.qrType] = a1;
        }
        BsyUtils.Store.set(this._getQrStyleKey(this.props.appId, this.props.entryId), a);
        this._showPdf(t)

    }

    _showPdf = (e) => {
        var i = this.options

        React.axios(`/data/batch_qr`, e)
            .then((res) => {
                BsyUtils.showAjaxTip(res.data, () => {
                    if (this.props.onCancel) {
                        this.props.onCancel();
                    }
                    if (BsyUtils.isSupportPdf()) {
                        BsySlidePane({
                            title: i.formName,
                            hasHeader: true,
                            onContentCreate: (ref) => {
                                return <embed src={res.data.url} width="100%" height="100%" style={{ position: 'absolute' }} type="application/pdf" />
                            },
                        })
                    } else {
                        BsyUtils.redirectTo(e.url, '_blank')
                    }
                })
            })
    }

    render() {
        const { qrType, qrStyle, field, qrFields } = this.state;
        return (
            <div className={"bsy-batch-print-qrcode-pane"} ref={this.element}>
                <div className='set-body'>
                    <div className="qrcode-type">
                        <div className="title">{React.language('print.qrcode.type')}</div>
                        <div className='field-text'>
                            <BsySelect
                                allowBlank={false}
                                searchable={false}
                                value={qrType}
                                items={[
                                    { text: React.language("print.qrcode.data"), value: 'data' },
                                    { text: React.language("print.qrcode.field"), value: 'field' }
                                ]}
                                onStopEdit={(val) => {
                                    this.setState({
                                        qrType: val,
                                    }, () => {
                                        this.renderFields();
                                    })
                                }}
                            ></BsySelect>
                            {
                                qrType === 'data' ? <div className='select-field'
                                    ref={this.fieldRef}
                                ></div> : <BsySelect
                                    allowBlank={false}
                                    searchable={false}
                                    value={field}
                                    customCls={'qr-field'}
                                    items={qrFields}
                                    onStopEdit={(val) => {
                                        this.setState({
                                            field: val,
                                        })
                                    }}
                                ></BsySelect>
                            }


                        </div>
                        <div className="tip">{React.language('print.qrcode.data.tip')}</div>
                    </div>

                    <div className="separator"></div>
                    <div className="page-setting">
                        <div className="title">{React.language('print.paper.set')}</div>
                        <div className='print-content'>

                            <div className="print-demo"><div className={`layout-${qrStyle.grid.col}-${qrStyle.grid.row}`}></div></div>
                            <div className='print-setting'>
                                <div className="qrcode-layout">
                                    <div className="title">{React.language('print.qrcode.layout.number')}</div>
                                    <BsyRadioGroup
                                        layout={'horizontal'}
                                        value={`-${qrStyle.grid.col}-${qrStyle.grid.row}`}
                                        items={[{
                                            value: "-1-1",
                                            text: '1x1',
                                        }, {
                                            value: "-1-2",
                                            text: '1x2',
                                        }, {
                                            value: "-2-3",
                                            text: '2x3',
                                        }, {
                                            value: "-3-4",
                                            text: '3x4',
                                        }]}
                                        onStopEdit={(e) => {
                                            let newqrStyle = { ...this.state.qrStyle };
                                            switch (e) {
                                                case "-1-1": {
                                                    newqrStyle.grid = { row: 1, col: 1 };
                                                    break;
                                                }
                                                case "-1-2": {
                                                    newqrStyle.grid = { row: 2, col: 1 };
                                                    break;
                                                }
                                                case "-2-3": {
                                                    newqrStyle.grid = { row: 3, col: 2 };
                                                    break;
                                                }
                                                case "-3-4": {
                                                    newqrStyle.grid = { row: 4, col: 3 };
                                                    break;
                                                }
                                                default: {
                                                    newqrStyle.grid = { row: 4, col: 3 };
                                                }
                                            }
                                            this.setState({
                                                qrStyle: newqrStyle,
                                            })
                                        }}
                                    ></BsyRadioGroup>
                                </div>
                                <div className="page-margin">
                                    <div className="title">{React.language('print.paper.padding')}</div>
                                    <div className="margin-input"><span>{React.language('print.paper.padding.top')}</span>
                                        <BsyNumber
                                            customCls={'margin-num'}
                                            width={50}
                                            value={BsyUtils.parsePt2Mm(qrStyle.margin[0])}
                                            onStopEdit={(val) => {
                                                let newqrStyle = { ...this.state.qrStyle };
                                                newqrStyle.margin[0] = BsyUtils.parseMm2Pt(val) || 0;
                                                this.setState({
                                                    qrStyle: newqrStyle,
                                                })
                                            }}
                                        />
                                        <span>mm</span>
                                    </div>
                                    <div className="margin-input"><span>{React.language('print.paper.padding.bottom')}</span>
                                        <BsyNumber
                                            customCls={'margin-num'}
                                            value={BsyUtils.parsePt2Mm(qrStyle.margin[2])}
                                            onStopEdit={(val) => {
                                                let newqrStyle = { ...this.state.qrStyle };
                                                newqrStyle.margin[2] = BsyUtils.parseMm2Pt(val) || 0;
                                                this.setState({
                                                    qrStyle: newqrStyle,
                                                })
                                            }}
                                        />
                                        <span>mm</span>
                                    </div>
                                    <div className="margin-input"><span>{React.language('print.paper.padding.left')}</span>
                                        <BsyNumber
                                            customCls={'margin-num'}
                                            width={50}
                                            value={BsyUtils.parsePt2Mm(qrStyle.margin[3])}
                                            onStopEdit={(val) => {
                                                let newqrStyle = { ...this.state.qrStyle };
                                                newqrStyle.margin[3] = BsyUtils.parseMm2Pt(val) || 0;
                                                this.setState({
                                                    qrStyle: newqrStyle,
                                                })
                                            }}
                                        />
                                        <span>mm</span>
                                    </div>
                                    <div className="margin-input"><span>{React.language('print.paper.padding.right')}</span>
                                        <BsyNumber
                                            customCls={'margin-num'}
                                            width={50}
                                            value={BsyUtils.parsePt2Mm(qrStyle.margin[1])}
                                            onStopEdit={(val) => {
                                                let newqrStyle = { ...this.state.qrStyle };
                                                newqrStyle.margin[1] = BsyUtils.parseMm2Pt(val) || 0;
                                                this.setState({
                                                    qrStyle: newqrStyle,
                                                })
                                            }}
                                        />
                                        <span>mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tip tip-warning">{React.language('print.qrcode.padding.tip')}</div>
                    </div>
                </div>

                <div className="edit-footer">
                    {/* <div className="edit-btn-left" onClick={this.batchUpdataList}>{React.language('data.batch.edit.record.view')}</div> */}

                    <BsyButton
                        mode={window.mode}
                        text={React.language('print')}
                        type={"blue edit-btn"}
                        click={(e) => {
                            this.onPrint();

                        }}
                    />
                    <BsyButton
                        mode={window.mode}
                        type={'edit-btn'}
                        text={React.language('cancel')}
                        click={(e) => {
                            if (this.props.onCancel) {
                                this.props.onCancel();
                            }
                        }}
                    />

                </div>
            </div>
        );
    }
}
